import { render } from "./Cabinet.vue?vue&type=template&id=315d004e"
import script from "./Cabinet.vue?vue&type=script&lang=js"
export * from "./Cabinet.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__